import { render, staticRenderFns } from "./ThemePreview.vue?vue&type=template&id=53308c3a&scoped=true"
import script from "./ThemePreview.vue?vue&type=script&lang=js"
export * from "./ThemePreview.vue?vue&type=script&lang=js"
import style0 from "./ThemePreview.vue?vue&type=style&index=0&id=53308c3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53308c3a",
  null
  
)

export default component.exports